export const environment = {
    production: true,
    api: {
        core: {
            endpoint: 'https://webapi.klasselotteriet.dk/api/'
        },
        drawlist : {
            endpoint: 'https://localhost:44390/api/PdfWebDisplay'
        }
    },
    dibs: {
        merchant: '4206817',
        callbackUrl: 'https://webapi.klasselotteriet.dk/api/securepaycallback'
    },
    nets: {
        merchantId: '911725',
        terminalUrl: 'https://epayment.nets.eu/Terminal/default.aspx'
    },
    appInsights: {
        instrumentationKey: 'd3b01c5d-bc00-4ed6-a910-bd94f4b14a99'
    },
    tracking: {
        enable: true,
        mediamathVisitSite: '//pixel.mathtag.com/event/js?mt_id=1583294&mt_adid=252732&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=',
        mediamathCompetitionReciept: '//pixel.mathtag.com/event/js?mt_id=1583556&mt_adid=252732&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=',
        mediamathPurchaseReciept: '//pixel.mathtag.com/event/js?mt_id=1583295&mt_adid=252732&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3='
    }
};
